import React, { useState, useEffect, useRef } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
// import Stack from '@material-ui/core/Stack';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

const styles = {
    container: {
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: "#ccc",
        borderRadius: 5,
        margin: 10,
        padding: 10
    }
};


function parseToJson(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return str;
    }
}

function stringifyJson(o) {
    try {
        return JSON.stringify(o);
    } catch (e) {
        return o;
    }
}



export default function SocketActions({ socket }) {
    const [eventName, setEventName] = useState("test-socket-event-to-server");
    const [retMsg, setRetMsg] = useState("1");
    const [data, setData] = useState("{key: 'val'}");
    const [ack, setAck] = useState(false);
    const [listenEvent, setListenEvent] = useState("test-socket-event-to-client");
    const [lastListenEvent, setLastListenEvent] = useState(null);
    const [isListening, setIsListening] = useState(false);
    const [log, setLog] = useState("");
    const logRef = useRef("");

    function appendLog(str, type) {
        logRef.current = `${type === 0 ? "↑↑" : type === 1 ? "↓↓" : "xx"} ${new Date().toLocaleString()} :- ${str}\r\n${logRef.current}`;
        setLog(logRef.current)
    }

    useEffect(() => {
        if (!!socket) {
            socket.on("success", (ret, resp) => {
                appendLog(`success :- Retrun Msg - ${stringifyJson(ret)} : Response - ${stringifyJson(resp)}`, 1);
            });

            socket.on("failure", (ret, resp) => {
                appendLog(`failure :- Retrun Msg - ${stringifyJson(ret)} : Response - ${stringifyJson(resp)}`, 1);
            });

            socket.on("pong-test", () => {
                appendLog(`pong`, 1);
            });
        }
        // eslint-disable-next-line
    }, [socket])

    const ackCallback = (response) => {
        appendLog(`emit-callback :- ${JSON.stringify(response)}`, 1);
    }

    const sendMessage = () => {
        try {
            if (!!socket && socket.connected) {

                let params = [eventName.trim()];
                let paramsString = `"${[eventName.trim()]}"`;

                if (!!retMsg && retMsg.trim().length > 0) {
                    params.push(parseToJson(retMsg.trim()));
                    paramsString += `, "${parseToJson(retMsg.trim())}"`;
                }

                if (!!data && data.trim().length > 0) {
                    params.push(parseToJson(data.trim()));
                    paramsString += `, "${parseToJson(data.trim())}"`;
                }
                if (ack) {
                    params.push(ackCallback);
                    paramsString += `", ackCallback"`;
                }
                socket.emit(...params);
                appendLog(`emit :- socket.emit(${paramsString})`, 0);
            }
        } catch (error) {
            appendLog(`Socket Error - ${error.message}`, -1);
        }
    }

    const sendPing = () => {
        try {
            if (!!socket && socket.connected) {
                socket.emit("ping-test");
                appendLog(`ping`, 0);
            }
        } catch (error) {
            appendLog(`Socket Error - ${error.message}`, -1);
        }
    }

    const listenSocketEvent = () => {

        const newEvent = listenEvent.trim();

        if (!!socket && socket.connected) {
            //remove the last listerner
            if (newEvent.length > 0 && lastListenEvent !== newEvent) {
                socket.removeAllListeners(lastListenEvent);
                socket.on(newEvent, resp => {
                    appendLog(`${listenEvent.trim()} :- ${stringifyJson(resp)}`, 1);
                });
                setLastListenEvent(newEvent);
                setIsListening(true);
            }
        }
    }

    const stopListeningEvent = () => {
        socket.removeAllListeners(listenEvent.trim());
        setLastListenEvent(null);
        setIsListening(false);
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6}>
                    <Box m={2} display="flex" flexDirection="column" justifyContent="center" style={styles.container}>
                        <Typography variant="h6" align="center">Emit Event</Typography>
                        <TextField
                            id="txt-event"
                            label="Event (required)"
                            variant="standard"
                            multiline
                            value={eventName}
                            onChange={e => setEventName(e.target.value)}
                            disabled={!socket || !socket.connected}
                        />
                        <TextField
                            id="txt-type"
                            label="Return Identifier (Thread Type)"
                            variant="standard"
                            multiline
                            value={retMsg}
                            onChange={e => setRetMsg(e.target.value)}
                            disabled={!socket || !socket.connected}
                        />
                        <TextField
                            id="txt-data"
                            label="Data (JSON)"
                            variant="standard"
                            multiline
                            value={data}
                            onChange={e => setData(e.target.value)}
                            disabled={!socket || !socket.connected}
                        />
                        <Box m={2} display="flex" flexDirection="column" alignItems="center">
                            <Box display="flex" alignItems="center" justifyContent="center">
                                <Checkbox
                                    checked={ack}
                                    onChange={e => setAck(e.target.checked)}
                                    disabled={!socket || !socket.connected}
                                />
                                <Typography> Acknowledgement (Callback Expected)</Typography>
                            </Box>
                            {!!eventName && eventName.trim().length > 0 &&
                                <Button
                                    variant="contained"
                                    onClick={sendMessage}
                                    disabled={!socket || !socket.connected}
                                >
                                    Emit Message
                                </Button>}
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <Box>
                        <Box m={2} display="flex" flexDirection="column" justifyContent="center" style={styles.container}>
                            <Typography variant="h6" align="center">Listen To Event</Typography>
                            <TextField
                                id="txt-event-listen"
                                label="Event (required)"
                                variant="standard"
                                multiline
                                value={listenEvent}
                                onChange={e => setListenEvent(e.target.value)}
                                disabled={isListening || !socket || !socket.connected}
                            />
                            <Box m={2} display="flex" flexDirection="column" alignItems="center">

                                {!isListening && !!listenEvent && listenEvent.trim().length > 0 &&
                                    <Button
                                        variant="contained"
                                        onClick={listenSocketEvent}
                                        disabled={!socket || !socket.connected}
                                    >
                                        Listen
                                    </Button>}
                                {isListening &&
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={stopListeningEvent}
                                        disabled={!socket || !socket.connected}
                                    >
                                        Stop
                                    </Button>}
                            </Box>
                        </Box>
                        <Box display="flex" flexDirection="column" alignItems="center" style={styles.container}>
                            <Typography variant="h6" align="center">Ping Test</Typography>
                            <Box m={2}>
                                <Button
                                    variant="contained"
                                    onClick={sendPing}
                                    disabled={!socket || !socket.connected}>Ping</Button>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>


            <Box m={2} display="flex" flexDirection="column" style={styles.container}>
                <Box m={2} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Socket Log</Typography>
                    <Button
                        variant="contained"
                        onClick={() => {
                            logRef.current = "";
                            setLog(logRef.current);
                        }}
                        disabled={!socket || !socket.connected || log.length === 0}
                    >
                        Clear Log</Button>
                </Box>
                <Paper elevation={0} style={{ backgroundColor: "black", minHeight: 200, padding: 20 }}>
                    {log.length > 0 &&
                        <Typography
                            color="white"
                            component="span"
                            style={{
                                fontSize: 13,
                                whiteSpace: "pre-line"
                            }}
                        >
                            {log}
                        </Typography>}
                </Paper>
            </Box>
        </Box>
    )
}
